/**
 * Canonical data shapes produced by GQL-backed providers and consumed by charts.
 * Saved-query APIs use {@link SavedQueryDataType}; map between them via saved-query-mapping.
 */
export enum DataType {
  SINGLE = 'SINGLE',
  TIMESERIES = 'TIMESERIES',
  BREAKDOWN_SINGLE = 'BREAKDOWN_SINGLE',
  FLOW_BREAKDOWN_SINGLE = 'FLOW_BREAKDOWN_SINGLE',
  BREAKDOWN_TIMESERIES = 'BREAKDOWN_TIMESERIES',
  BOX = 'BOX',
  DISTRIBUTION = 'DISTRIBUTION',
  MAP = 'MAP',
  TABLE_ROWS = 'TABLE_ROWS',
  TEXT = 'TEXT',
}
